{
  "name": "kobito-frontend",
  "version": "1.79.6",
  "engines": {
    "node": "24.22.1"
  },
  "packageManager": "pnpm@11.23.0+sha512.f00082e5b283a199b74e079da28d155c008fe232f44c8a06ea7ddfa014ecf719fc362f790ecc67b28106ddac2afb24c49a9a079159da560b2ce7d1e98efd11af",
  "scripts": {
    "ng": "ng",
    "start": "pnpm run codegen && ng serve app",
    "build": "pnpm run codegen && ng build app",
    "build:development": "pnpm run codegen && ng build app -c development",
    "build:staging": "pnpm run codegen && ng build app -c staging",
    "build:production": "pnpm run codegen && ng build app -c production",
    "watch": "pnpm run codegen && ng build app --watch -c development",
    "test": "pnpm run codegen && ng test",
    "test:ci": "pnpm run codegen && ng test --no-watch --no-progress",
    "format": "prettier --cache --write 'src'",
    "format:check": "prettier --cache --check 'src'",
    "codegen": "pnpm run codegen:env && pnpm run codegen:kobito",
    "codegen:env": "tsx tools/envgen/main.ts -o src/environments/env.generated.ts",
    "codegen:kobito": "graphql-codegen --config tools/gqlgen/kobito.ts",
    "lint": "eslint ./",
    "e2e:open": "cypress open --config-file cypress/config/development.ts",
    "e2e:open:staging": "cypress open --config-file cypress/config/staging.ts",
    "e2e:run": "cypress run --config-file cypress/config/development.ts",
    "e2e:run:staging": "cypress run --config-file cypress/config/staging.ts"
  },
  "private": true,
  "dependencies": {
    "@angular/cdk": "22.2.1",
    "@angular/common": "22.2.1",
    "@angular/compiler": "22.2.1",
    "@angular/core": "22.2.1",
    "@angular/forms": "22.2.1",
    "@angular/localize": "22.2.1",
    "@angular/material": "22.2.1",
    "@angular/platform-browser": "22.2.1",
    "@angular/router": "22.2.1",
    "@apollo/client": "^4.0.11",
    "@auth0/auth0-angular": "^2.0.0",
    "@classi/ngx-google-analytics": "6.0.1",
    "@classi/training-ui": "2.10.6",
    "@sentry/angular": "^10.0.0",
    "@tailwindcss/postcss": "4.3.3",
    "angular-split": "^20.0.0",
    "apollo-angular": "^14.1.0",
    "extract-files": "^13.0.0",
    "filesize": "^11.0.0",
    "graphql": "^16.6.0",
    "graphql-tag": "^2.12.6",
    "jwt-decode": "^4.0.0",
    "katex": "^0.17.0",
    "postcss": "8.5.25",
    "rxjs": "~7.8.0",
    "tailwindcss": "^4.0.0",
    "tslib": "^2.3.0",
    "viewerjs": "^1.11.3",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@actions/core": "^3.0.0",
    "@actions/github": "^9.0.0",
    "@angular/build": "^22.2.1",
    "@angular/cli": "22.2.1",
    "@angular/compiler-cli": "22.2.1",
    "@classi/kobito-api-schema": "10.5.0",
    "@eslint/js": "^10.0.0",
    "@graphql-codegen/add": "^7.0.0",
    "@graphql-codegen/cli": "7.1.3",
    "@graphql-codegen/typed-document-node": "^7.0.0",
    "@graphql-codegen/typescript": "^6.0.0",
    "@graphql-codegen/typescript-operations": "^6.0.0",
    "@graphql-typed-document-node/core": "^3.2.0",
    "@testing-library/angular": "^19.4.1",
    "@testing-library/dom": "^10.1.0",
    "@testing-library/user-event": "^14.4.3",
    "@types/gtag.js": "^0.0.20",
    "@types/katex": "^0.16.0",
    "@vitest/browser": "4.1.10",
    "@vitest/browser-playwright": "4.1.10",
    "@vitest/eslint-plugin": "^1.0.1",
    "@vitest/ui": "4.1.10",
    "angular-eslint": "^22.1.0",
    "autoprefixer": "^10.4.16",
    "cypress": "^15.0.0",
    "eslint": "^10.0.0",
    "eslint-config-prettier": "^10.1.8",
    "globals": "^17.0.0",
    "graphql-codegen-typescript-mock-data": "^5.0.0",
    "jsdom": "^29.0.0",
    "msw": "2.14.6",
    "playwright": "^1.57.0",
    "postcss": "8.5.25",
    "prettier": "^3.0.0",
    "prettier-plugin-tailwindcss": "^0.8.0",
    "tsx": "^4.0.0",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.71.0",
    "vitest": "4.1.11"
  },
  "msw": {
    "workerDirectory": "src"
  }
}
